import { render } from "./DropOrder.vue?vue&type=template&id=4ee351b0"
import script from "./DropOrder.vue?vue&type=script&lang=js"
export * from "./DropOrder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__